"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectMeta = exports.selectItems = exports.selectInProcess = exports.resetStateAction = exports.reducer = exports.redirectToAction = exports.name = exports.getNotificationRequestSuccess = exports.getNotificationRequestFail = exports.getNotificationRequest = exports.addNotificationAction = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _toolkit = require("@reduxjs/toolkit");

var redirectToAction = (0, _toolkit.createAction)('redirect');
exports.redirectToAction = redirectToAction;
var REDUCER_NAME = 'widget/notification';
var initialState = {
  items: [],
  meta: {},
  inProcess: false
};
var applicationSlice = (0, _toolkit.createSlice)({
  name: REDUCER_NAME,
  initialState: initialState,
  reducers: {
    resetStateAction: function resetStateAction(state) {
      state['items'] = [];
      state['meta'] = {};
      state['inProcess'] = false;
    },
    getNotificationRequest: function getNotificationRequest(state) {
      state['inProcess'] = true;
    },
    getNotificationRequestFail: function getNotificationRequestFail(state) {
      state['inProcess'] = false;
    },
    getNotificationRequestSuccess: function getNotificationRequestSuccess(state, _ref) {
      var payload = _ref.payload;
      state['items'] = payload['data'];
      state['meta'] = payload['meta'];
      state['inProcess'] = false;
    },
    addNotificationAction: function addNotificationAction(state, _ref2) {
      var payload = _ref2.payload;
      state['items'] = [payload].concat((0, _toConsumableArray2["default"])(state['items'])).slice(0, 3);
    }
  }
});
var _applicationSlice$act = applicationSlice['actions'],
    resetStateAction = _applicationSlice$act.resetStateAction,
    getNotificationRequest = _applicationSlice$act.getNotificationRequest,
    getNotificationRequestFail = _applicationSlice$act.getNotificationRequestFail,
    getNotificationRequestSuccess = _applicationSlice$act.getNotificationRequestSuccess,
    addNotificationAction = _applicationSlice$act.addNotificationAction;
exports.addNotificationAction = addNotificationAction;
exports.getNotificationRequestSuccess = getNotificationRequestSuccess;
exports.getNotificationRequestFail = getNotificationRequestFail;
exports.getNotificationRequest = getNotificationRequest;
exports.resetStateAction = resetStateAction;

var selectItems = function selectItems(state) {
  return state[REDUCER_NAME]['items'];
};

exports.selectItems = selectItems;

var selectMeta = function selectMeta(state) {
  return state[REDUCER_NAME]['meta'];
};

exports.selectMeta = selectMeta;

var selectInProcess = function selectInProcess(state) {
  return state[REDUCER_NAME]['meta'];
};

exports.selectInProcess = selectInProcess;
var name = applicationSlice['name'];
exports.name = name;
var reducer = applicationSlice['reducer'];
exports.reducer = reducer;